
import Vue from 'vue';
import Vuex from 'vuex';
import axios from '../axios';
import * as constants from '../constants';
import visits from './visits';
import employees from './employees';
import machines from './machines';
import visitActions from './visit-actions';
import actions from './actions';
import agencies from './agencies';
import clients from './clients';

Vue.use(Vuex);

function isQuotaExceeded(e) {
  var quotaExceeded = false;
  if (e) {
    if (e.code) {
      switch (e.code) {
        case 22:
          quotaExceeded = true;
          break;
        case 1014:
          // Firefox
          if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
            quotaExceeded = true;
          }
          break;
      }
    } else if (e.number === -2147024882) {
      // Internet Explorer 8
      quotaExceeded = true;
    }
  }
  return quotaExceeded;
}

export default new Vuex.Store({

  strict: true,

  modules: {
    visits,
    employees,
    machines,
    visitActions,
    actions,
    agencies,
    clients
  },

  state: {
    user: null,
    isMobile: false,
    screenSize: null,
    centerViewVertical: false,
    pageTitle: '',
    token: null,
    fromPage: null
  },

  actions: {
    LOAD_USER({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get(`${constants.SERVER_URL}/api/user`)
          .then(response => response.data)
          .then(response => {
            commit('USER', response);
            resolve(response);
          }, (error) => {
            reject(error);
          });
      });
    },

    USER_EVENT({ commit }, name) {
      return axios.post(`/api/event`, { name });
    },

    LOGIN({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.post(`${constants.SERVER_URL}/api/login`, data)
          .then(response => {
            commit('TOKEN', response.data);
            resolve(response);
          }, (error) => {
            reject(error);
          });
      });
    }

  },

  mutations: {

    USER(state, payload) {
      this.state.user = payload;
    },

    SCREEN_SIZE(state, payload) {
      this.state.screenSize = payload;
    },

    IS_MOBILE(state, payload) {
      this.state.isMobile = payload;
    },

    CENTER_VIEW_VERTICAL(state, payload) {
      this.state.centerViewVertical = payload;
    },

    PAGE_TITLE(state, payload) {
      this.state.pageTitle = payload;
    },

    TOKEN(state, payload) {
      state.token = payload;
      try {
        payload ? localStorage.setItem('token', payload) : localStorage.removeItem('token');
      } catch (error) {
        if (isQuotaExceeded(error)) {
          console.log('Not enough storage');
        }
      }
      axios.defaults.headers.common.Authorization = `Bearer ${payload}`;
    },

    FROM_PAGE(state, payload) {
      this.state.fromPage = payload;
    }

  },

  getters: {
  }
});
